import { ReservationSeatingDto } from 'gleblu-socket-api';
import moment from 'moment-timezone';

import { ReservationSeating } from '../interfaces/reservation/Reservation';

export function fromDto(reservationSeatingDto: ReservationSeatingDto): ReservationSeating {
  const { uuid, reservationUuid, mergedTableUuid, timeInterval } = reservationSeatingDto;
  return {
    uuid,
    reservationUuid,
    mergedTableUuid,
    startDate: moment(timeInterval.startDate),
    endDate: moment(timeInterval.endDate),
  };
}

export function toDto(reservationSeating: ReservationSeating): ReservationSeatingDto {
  const { uuid, reservationUuid, mergedTableUuid, startDate, endDate } = reservationSeating;
  return {
    uuid,
    reservationUuid,
    mergedTableUuid,
    timeInterval: {
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
    },
  };
}
